<template>
  <div>
    <sweet-modal ref="modal" width="40%" hide-close-button blocking>
      <form>
        <h3 class="mb-5">{{ $t('ct-create-website')}}</h3>
        <div class="form-group">
          <label for="title">{{ $t('ct-title') }}</label>
          <input
            type="text"
            name="title"
            id="title"
            required="required"
            v-model="newSite.title"
            class="form-control form-control-line"
            :class="{'is-invalid': errors && errors.title }"
            minlength="3"
            @keydown="errors.clear('title')"
          />
          <span
            v-if="errors.has('title')"
            class="invalid-feedback"
            :class="{ 'd-block' : errors.has('title')}"
            v-text="errors.get('title')"
          ></span>
        </div>

        <div class="form-group">
          <label for="description">{{ $t('ct-description') }}</label>
          <textarea
            name="description"
            v-model="newSite.description"
            class="form-control form-control-line"
            :class="{'is-invalid': errors && errors.description }"
          ></textarea>
          <span
            v-if="errors.has('description')"
            class="invalid-feedback"
            v-text="errors.get('description')"
          ></span>
        </div>

        <div class="form-group" :class="{ 'was-validated': errors.has('typeInitial') }">
          <label>{{ $t('ct-choose-creation-type') }}</label>
          <div class="d-flex flex-row container-box-choose-profile">
            <div class="bg-white" :class="{ 'selected': newSite.typeInitial === 'build' }">
              <input
                type="radio"
                id="typeBuild"
                name="type_initial"
                value="build"
                @click="changeTypeInitial('build')"
                class="d-none"
              />
              <label for="typeBuild">{{ $t('ct-blank-template') }}</label>
            </div>

            <div class="bg-white" :class="{ 'selected': newSite.typeInitial === 'template' }">
              <input
                type="radio"
                id="typeTemplate"
                name="type_initial"
                value="template"
                @click="changeTypeInitial('template')"
                class="d-none"
              />
              <label for="typeTemplate">{{ $t('ct-choose-a-template') }}</label>
            </div>

            <div class="bg-white" :class="{ 'selected': newSite.typeInitial === 'smartTemplate' }">
              <input
                type="radio"
                id="typeSmartTemplate"
                name="type_initial"
                value="smartTemplate"
                @change="changeTypeInitial('smartTemplate')"
                class="d-none"
              />
              <label for="typeSmartTemplate">{{ $t('ct-choose-smart-template') }}</label>
            </div>
            <span
              v-if="errors.has('typeInitial')"
              class="invalid-feedback"
              v-text="errors.get('typeInitial')"
            ></span>
          </div>
        </div>
      </form>
      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancel('modal')"
      >{{ $t('ct-cancel') }}</button>
      <!--
      <button slot="button" class="btn btn-outline-primary" @click="next()">{{ $t('ct-next') }}</button>
      -->
    </sweet-modal>

    <sweet-modal ref="confirmSave" width="30%" hide-close-button blocking>
      <div>{{ $t('ct-do-you-want-save-site') }}</div>
      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancel('confirmSave')"
      >{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-outline-primary" @click="save()"><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
    </sweet-modal>


    <!-- MODAL USER NOT HAVE GROUP -->
    <sweet-modal ref="userNotHaveGroup" width="25%" hide-close-button blocking>
      <div>{{ $t('ct-dont-have-a-tag-group-do-you-want-create')}}</div>
      <slot name="content"></slot>
      <button
        slot="button"
        class="btn btn-outline-light"
        v-on:click="cancel('userNotHaveGroup')"
      >{{ $t('ct-cancel') }}</button>
      <button
        slot="button"
        class="btn btn-outline-primary"
        @click="$router.push('/tags')"
      >{{ $t('ct-create-group') }}</button>
    </sweet-modal>

    <div class="box-modal-choose-builder">
      <sweet-modal ref="build" width="95%" hide-close-button blocking>
        <section class="container-box-choose-layout">
          <div class="box-menu">
            <h1>{{ this.build.steps[stepOn].title}}</h1>
            <ul class="list-group-layout list-only">
              <li
                class="list-item"
                :class="{'active': stepOn === 'header'}"
              >Step 01 {{ $t('ct-header') }}</li>
              <li
                class="list-item"
                :class="{'active': stepOn === 'footer'}"
              >STEP 02 {{ $t('ct-footer') }}</li>
              <li
                class="list-item"
                :class="{'active': stepOn === 'body'}"
              >STEP 03 {{ $t('ct-body') }}</li>
            </ul>
          </div>
          <div class="box-container-list" style="overflow-x: hidden;">
            <div class="w-100">
              <span class="subtitle">{{ this.build.steps[stepOn].subTitle}}</span>
              <span
                class="subtitle invalid-feedback"
                v-if="errors && errors.build"
              >{{ $t('ct-required-choose-one-template')}}</span>
            </div>
            <div
              class="box-list flex-row"
              :class=" stepOn !== 'header' ? 'd-none': 'd-flex'"
              ref="header"
            >
              <div
                class="box box-template"
                @click="changeBuild('header','header1')"
                data-header-id="header1"
                :class="{'selected': newSite.typeBuilder.build.header === 'header1'}"
              >
                <div class="box-template-info">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTjowe158LMnx77CjYin4Lgkz9IdeF974Jar6q2i0aRP9FMCYEb"
                  />
                  <div class="box-template-overlay">
                    <button class="btn btn-outline-light">{{ $t('ct-preview') }}</button>
                  </div>
                </div>
                <span class="title-template">{{ $t('ct-header') }}</span>
              </div>

              <div
                class="box box-template"
                @click="changeBuild('header','header2')"
                data-header-id="header2"
                :class="{'selected': newSite.typeBuilder.build.header === 'header2'}"
              >
                <div class="box-template-info">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTjowe158LMnx77CjYin4Lgkz9IdeF974Jar6q2i0aRP9FMCYEb"
                  />
                  <div class="box-template-overlay">
                    <button class="btn btn-outline-light">{{ $t('ct-preview') }}</button>
                  </div>
                </div>
                <span class="title-template">{{ $t('ct-header') }}</span>
              </div>
            </div>
            <div
              class="box-list flex-row"
              :class=" stepOn !== 'footer' ? 'd-none': 'd-flex'"
              ref="footer"
            >
              <div
                class="box box-template"
                @click="changeBuild('footer','footer1')"
                data-footer-id="footer1"
                :class="{'selected': newSite.typeBuilder.build.footer === 'footer1'}"
              >
                <div class="box-template-info">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTjowe158LMnx77CjYin4Lgkz9IdeF974Jar6q2i0aRP9FMCYEb"
                  />
                  <div class="box-template-overlay">
                    <button class="btn btn-outline-light">{{ $t('ct-preview') }}</button>
                  </div>
                </div>
                <span class="title-template">{{ $t('ct-footer') }}</span>
              </div>
            </div>

            <div
              class="box-list flex-row"
              :class=" stepOn !== 'body' ? 'd-none': 'd-flex'"
              ref="body"
            >
              <div
                class="box box-template"
                @click="changeBuild('body','body1')"
                data-body-id="body1"
                :class="{'selected': newSite.typeBuilder.build.body === 'body1'}"
              >
                <div class="box-template-info">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTjowe158LMnx77CjYin4Lgkz9IdeF974Jar6q2i0aRP9FMCYEb"
                  />
                  <div class="box-template-overlay">
                    <button class="btn btn-outline-light">{{ $t('ct-preview') }}</button>
                  </div>
                </div>
                <span class="title-template">{{ $t('ct-body') }}</span>
              </div>
            </div>
          </div>
        </section>
        <button
          slot="button"
          class="btn btn-outline-light"
          v-on:click="cancel('build')"
        >{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-outline-light"
          v-on:click="backBuilder('build','modal', stepOn)"
        >{{ $t('ct-back') }}</button>
        <button
          slot="button"
          class="btn btn-outline-primary"
          v-on:click="nextBuilder('build','modal', stepOn)"
        >{{ $t('ct-next') }}</button>
      </sweet-modal>

      <!-- MODAL TEMPLATE -->
      <sweet-modal ref="template" width="95%" hide-close-button blocking>
        <section class="container-box-choose-layout">
          <div class="box-menu">
            <h1>{{ $t('ct-choose-a-template')}}</h1>

            <ul class="nav flex-column list-group-layout">
              <li class="list-item">
                <a
                  href="#nav-all"
                  id="nav-all-tab"
                  class="nav-item navlink active"
                  data-toggle="tab"
                >{{ $t('ct-alll-templates')}}</a>
              </li>
              <li
                v-for="(category, index) in all_categories"
                v-if="category.show"
                :key="index"
                class="list-item"
              >
                <a
                  :href="'#nav-category-' + category.id"
                  id="nav-personal-tab"
                  class="nav-item navlink"
                  data-toggle="tab"
                >{{ $t(category.description) }}</a>
              </li>
            </ul>
          </div>
          <div class="box-container-list" style="overflow-x: hidden;">
            <div class="w-100">
              <span class="subtitle">{{ $t('ct-choose-a-template')}}</span>
            </div>

            <div class="tab-content" id="nav-TabContent">
              <div class="tab-pane fade show active box-list row" id="nav-all">
                <div
                  v-for="(template) in all_templates"
                  style="max-width: 220px; cursor: pointer"
                  class="box box-template"
                  :class="( newTemplateSelected ===  template.encrypted_id) ? 'selected' : ''"
                  @click="selectTemplate(template.encrypted_id)"
                >
                  <div class="box-template-info">
                    <img :src="template.thumbnail_portrait" />
                    <div class="box-template-overlay">
                      <a
                        :href="`${appUrl}?from=editor#/template-preview/${template.title}`"
                        target="_blank"
                        class="btn btn-light"
                        @click="selectTemplate(template.encrypted_id)"
                      >{{ $t('ct-preview') }}</a>
                    </div>
                  </div>
                  <span class="title-template">{{ $t(template.title) }}</span>
                </div>
              </div>
              <div
                v-for="(category, index) in all_categories"
                class="tab-pane fade box-list row"
                :id="'nav-category-' + category.id"
              >
                <div
                  v-for="(template) in category.templates"
                  style="max-width: 220px; cursor: pointer"
                  class="box box-template"
                  :class="( newTemplateSelected ===  template.encrypted_id) ? 'selected' : ''"
                  @click="selectTemplate(template.encrypted_id)"
                >
                  <div class="box-template-info">
                    <img :src="template.thumbnail_portrait" />
                    <div class="box-template-overlay">
                      <a
                        :href="`${appUrl}?from=editor#/template-preview/${template.title}`"
                        target="_blank"
                        class="btn btn-light"
                        @click="selectTemplate(template.encrypted_id)"
                      >{{ $t('ct-preview') }}</a>
                    </div>
                  </div>

                  <span class="title-template">{{ $t(template.title) }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <button
          slot="button"
          class="btn btn-outline-light"
          v-on:click="back('template', 'modal')"
        >{{ $t('ct-back') }}</button>
        <button
          slot="button"
          class="btn btn-outline-danger"
          v-on:click="cancel('template')"
        >{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-outline-primary"
          v-on:click="transferAndFinish"
        >{{ $t('ct-save') }}</button>
      </sweet-modal>

      <!-- MODAL SMART-TEMPLATE -->
      <sweet-modal ref="smartTemplate" width="95%" hide-close-button blocking>
        <section class="container-box-choose-layout">
          <!-- MENU -->
          <div class="box-menu">
            <h1>{{ $t('ct-choose-a-template')}}</h1>

            <ul class="nav flex-column list-group-layout">
              <li class="list-item">
                <a
                  href="#nav-all"
                  id="nav-all-tab"
                  class="nav-item navlink active"
                  data-toggle="tab"
                >{{ $t('ct-alll-templates')}}</a>
              </li>
              <li
                v-for="(category, index) in all_categories"
                v-if="category.show"
                :key="index"
                class="list-item"
              >
                <a
                  :href="'#nav-category-' + category.id"
                  id="nav-personal-tab"
                  class="nav-item navlink"
                  data-toggle="tab"
                >{{ $t(category.description) }}</a>
              </li>
            </ul>
          </div>

          <!-- TEMPLATE LIST -->
          <div class="box-container-list" style="overflow-x: hidden;">
            <div class="box-container-list-header">
              <span class="subtitle">{{ $t('ct-choose-a-template')}}</span>

              <div>
                <span class="subtitle">Select tag group</span>
                <button
                  type="button"
                  class="btn btn-filter dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <font-awesome-icon :icon="['fas', 'sort']" class="font-awesome-icon sort-icon" />
                  {{ group.name  || $t('ct-groups')}}
                </button>
                <div class="dropdown-menu centered">
                  <span
                    v-for="group in tagGroups"
                    :key="group.id"
                    href="#"
                    class="dropdown-item"
                    @click="chooseTagGroup(group)"
                  >{{ group.name }}
                  </span>
                </div>
              </div>
            </div>

            <div class="tab-content" id="nav-TabContent">
              <div class="tab-pane fade show active box-list row" id="nav-all">
                <div
                  v-for="(template) in all_templates"
                  style="max-width: 220px; cursor: pointer"
                  class="box box-template"
                  :class="( newTemplateSelected ===  template.encrypted_id) ? 'selected' : ''"
                  @click="selectTemplate(template.encrypted_id)"
                >
                  <div class="box-template-info">
                    <img :src="template.thumbnail_portrait" />
                    <div class="box-template-overlay">
                      <a
                        :href="`${appUrl}?from=editor#/template-preview/${template.title}`"
                        target="_blank"
                        class="btn btn-light"
                        @click="selectTemplate(template.encrypted_id)"
                      >{{ $t('ct-preview') }}</a>
                    </div>
                  </div>
                  <span class="title-template">{{ $t(template.title) }}</span>
                </div>
              </div>
              <div
                v-for="(category, index) in all_categories"
                class="tab-pane fade box-list row"
                :id="'nav-category-' + category.id"
              >
                <div
                  v-for="(template) in category.templates"
                  style="max-width: 220px; cursor: pointer"
                  class="box box-template"
                  :class="( newTemplateSelected ===  template.encrypted_id) ? 'selected' : ''"
                  @click="selectTemplate(template.encrypted_id)"
                >
                  <div class="box-template-info">
                    <img :src="template.thumbnail_portrait" />
                    <div class="box-template-overlay">
                      <a
                        :href="`${appUrl}?from=editor#/template-preview/${template.title}`"
                        target="_blank"
                        class="btn btn-light"
                        @click="selectTemplate(template.encrypted_id)"
                      >{{ $t('ct-preview') }}</a>
                    </div>
                  </div>

                  <span class="title-template">{{ $t(template.title) }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <button
          slot="button"
          class="btn btn-outline-light"
          v-on:click="cancel('smartTemplate')"
        >{{ $t('ct-cancel') }}</button>
        <button
          slot="button"
          class="btn btn-outline-primary"
          v-on:click="transferAndFinish"
        ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import ModalComponent from "../../components/Modal.vue";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Errors from "../../../../js/base/Errors";
import {
  transferDuplicateTemplate,
  create as createWebsite
} from "../../../../js/services/editor/website";
import { getGroups } from "../../../../js/services/editor/autotag";

import { getAll as getTemplates } from "../../../../js/services/editor/template";

export default {
  name: "SiteNew",
  props: ["newSite", "categories", "languages"],
  components: { ModalComponent, SweetModal, SweetModalTab },
  data() {
    return {
      errors: new Errors(),
      stepOn: "header",
      all_templates: [],
      all_categories: [],
      tagGroups: [],
      group: {
        id: '',
        name: ''
      },

      newTemplateSelected: "",
      build: {
        steps: {
          header: {
            title: "Choose Header",
            subTitle:
              "Escolha um header, lembrando, que você pode modificar depois dentro do editor."
          },
          footer: {
            title: "Choose Footer",
            subTitle:
              "Escolha um footer, lembrando, que você pode modificar depois dentro do editor."
          },
          body: {
            title: "Choose Body",
            subTitle:
              "Escolha um body, lembrando, que você pode modificar depois dentro do editor."
          }
        }
      }
    };
  },
  watch: {
    "newSite.showModal": function(value) {
      this.toogleModal(value);
    }
  },

  computed: {
    appUrl() {
      return typeof process.env.APP_URL !== 'undefined' ? process.env.APP_URL : 'https://cheetah-editor.builderall.com';
    },
    domain() {
      return typeof process.env.TEMPLATE_DOMAIN !== 'undefined' ? process.env.TEMPLATE_DOMAIN : '.template.builderall.com';
    }
  },

  methods: {
    selectTemplate(encrypted_id) {
      this.newTemplateSelected = encrypted_id;
    },

    transferAndFinish() {

      if(this.newSite.typeInitial === "smartTemplate"){
        if(this.group.id === ''){
           this.$snotify.error(
            this.$t(
              'ct-select-tag-group',
              'Something happened when trying to publish your site, check the settings'
            )
          );
          return;
        }
      }

      if (typeof this.newTemplateSelected !== "") {
        this.$loading.show();
        transferDuplicateTemplate(
          { encrypted_id: this.newTemplateSelected },
          { title: this.newSite.title, description: this.newSite.description, type: this.newSite.typeInitial, group: this.group.id}
        ).then(res => {
          if (res.data.success === false) {
            this.$snotify.warning(this.$t(res.data.error));

            this.cancel(this.newSite.typeInitial);
            this.$loading.hide();
          } else {
            this.cancel(this.newSite.typeInitial);
            this.$loading.hide();
            this.$emit("confirmSave", {'encrypted_id': res.data.website.encrypted_id});
          }
        });
      } else {
        alert("select template first");
      }
    },
    chooseTagGroup(group) {
      this.group = group;
    },
    confirmSave() {
      this.close(this.newSite.typeInitial);
      this.$refs.confirmSave.open();
    },
    changeTemplate(value) {
      let templateBoxSelected = this.$el.querySelector(
        `[data-template-id=${value}]`
      );
      let templateBoxAll = this.$el.querySelectorAll(`[data-template-id]`);

      if (templateBoxAll) {
        Object.keys(templateBoxAll).forEach(index => {
          templateBoxAll[index].classList.remove("selected");
        });
      }

      if (templateBoxSelected) {
        templateBoxSelected.classList.add("selected");
      }

      if (this.newSite.typeBuilder.template.idTemplate !== value) {
        this.newSite.typeBuilder.template.idTemplate = value;
      }
    },
    changeBuild(type, value) {
      this.errors.clear("build");
      if (this.newSite.typeBuilder.build[type] !== value) {
        this.newSite.typeBuilder.build[type] = value;
      }
    },
    changeTypeInitial(value) {
      this.newSite.typeInitial = value;
      this.errors.clear("typeInitial");
      this.next();
    },
    backBuilder(from, to, step) {
      if (typeof step !== "undefined") {
        switch (step) {
          case "body":
            this.stepOn = "footer";
            break;
          case "footer":
            this.stepOn = "header";
            break;
          case "header":
            this.back(from, to);
            break;
        }
      }
    },
    validateBuild(step) {
      if (
        this.newSite.typeBuilder.build[step] &&
        this.newSite.typeBuilder.build[step].length > 0
      ) {
        return true;
      } else {
        this.errors.add("build", `The type ${step} is required.`);
        console.log(this.errors);
        return false;
      }
    },
    nextBuilder(from, to, step) {
      if (step && this.validateBuild(step)) {
        switch (step) {
          case "header":
            this.stepOn = "footer";
            break;
          case "footer":
            this.stepOn = "body";
            break;
          case "body":
            this.confirmSave();
            break;
        }
      }
    },
    toogleModal(value) {
      if (value) {
        this.$refs.modal.open();
      } else {
        this.$refs.modal.close();
      }
    },
    save() {
      if (this.validate()) {
        createWebsite(this.newSite)
          .then(data => {

            console.log(data);
            if(data.data.success === false){
              this.$snotify.warning(this.$t(data.data.error));

              setTimeout(()=>{
                location.reload();
              },2000);
            }else{

              this.close("confirmSave");
              this.clearTypeInitial();
              this.$emit("confirmSave", data.data);
            }

          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.errors.record(error.response.data.errors);
            }
          });
      }
    },
    back(from, to) {
      this.$refs[from].close();
      this.$refs[to].open();
    },
    clearTypeInitial() {
      let radioTypeInitial = this.$el.querySelectorAll("[name=type_initial]");

      if (radioTypeInitial && radioTypeInitial.length > 0) {
        Object.keys(radioTypeInitial).forEach(index => {
          radioTypeInitial[index].checked = false;
        });
      }
    },
    cancel(modal) {
      this.clearTypeInitial();
      this.errors.clear();
      this.close(modal);
      this.$emit("clearNewSite");
    },
    close(modal) {
      this.newSite.showModal = false;
      this.stepOn = "header";
      this.$refs[modal].close();
    },
    async next() {
      if (this.validate()) {
        if (this.newSite.typeInitial === "build") {
          this.$refs.modal.close();
          // this.$refs.build.open();
          this.save();
        } else if (this.newSite.typeInitial === "template") {
          this.all_templates = [];
          this.all_categories = [];

          await getTemplates("normal").then( ({ data }) => {
            this.all_templates = data.templates;
            this.all_categories = data.categories;
          });

          this.$refs.modal.close();
          this.$refs.template.open();
        } else if (this.newSite.typeInitial === "smartTemplate") {
          this.all_templates = [];
          this.all_categories = [];
          this.$refs.modal.close();

          await getGroups().then(({ data }) => {
            this.tagGroups = data
          });

          if(!this.tagGroups.length) return this.$refs.userNotHaveGroup.open()

          await getTemplates("smart").then( ({ data }) => {
            this.all_templates = data.templates;
            this.all_categories = data.categories;
          });

          this.$refs.smartTemplate.open();
        } else {
          // Error escolhar um dos dois
        }
      }
    },
    validate() {
      // if (
      //   this.newSite.typeInitial === '' ||
      //   this.newSite.typeInitial.length === 0
      // )
      //   this.errors.add('typeInitial', 'The type builder is required.');

      if (this.newSite.title.length < 3) {
        this.errors.add("title", "field-must-be-at-least-3-characters");
      }

      if (this.newSite.title === "") {
        this.errors.add("title", "validation-required");
      }

      return !this.errors.any();
    }
  },
  mounted() {
    // getTemplates()
    //   .then(res => {
    //     this.all_templates = res.data.templates;
    //     this.all_categories = res.data.categories;
    //   });
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteNew.vue